import * as BABYLON from 'babylonjs';
import VisualComponent from './VisualComponent';
import MediaManager from '@/api/MediaManager';

class Viewer3D extends VisualComponent {
    getType() { return "Viewer3D"; }

    constructor( { id } = {} ) {
        super( { id });
    }

    construct(context, prefab) {
        const base = super.construct( context, prefab );

        if(prefab.getURL()){

            this.mesh.actionManager = new BABYLON.ActionManager(this.scene);
            
            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, () => {
                window.dispatchEvent(new CustomEvent("openViewer3D",{detail:{
                    meshURL: MediaManager.getMedia(prefab.getURL()).getURL(), 
                    name: prefab.getName(),
                }}));
            }));

            var ease = new BABYLON.CubicEase();
            ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);

            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, () => {
                BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 30,10, this.mesh.scaling, new BABYLON.Vector3.One(), 0, ease);  
            }));

            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, () => {
                BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 30,10, this.mesh.scaling, new BABYLON.Vector3.One().scale(1.1), 0, ease);
            }));
        }

        return base;
    }
    
}

export default Viewer3D;
